import { SendOption } from "schemas/dashboard";

import { Template } from "features/Influencer/ContactList/schema";

export type OrganizationBulkSendSettings = {
  numberOfBrands?: number;
  defaultNumberOfBrands?: number;
  numberOfRepitchBrands?: number;
  templateOption?: SendOption;
  timezone?: string;
  status?: BulkSendSettingsStatus;
  id?: number;
  personalizeOutreach?: boolean;
  version: OrganizationBulkSendSettingsVersion;
  emailSettingId?: number;
  additionalEmailCount?: number;

  // Only use on FE
  templates?: Template[];
};

export enum OrganizationBulkSendSettingsVersion {
  v1 = "v1",
  v2 = "v2",
  v3 = "v3",
}

export enum BulkSendSettingsStatus {
  active = "active",
  inactive = "inactive",
}
